var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20c7b9cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "statusCard shadowed" };
const _hoisted_2 = { class: "headerRow" };
const _hoisted_3 = { class: "nameAndCreated" };
const _hoisted_4 = { class: "name" };
const _hoisted_5 = { class: "applicationId ml-2" };
const _hoisted_6 = { class: "created pt-1" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "createdLabel" }, "Started: ", -1));
const _hoisted_8 = { class: "createdDate" };
const _hoisted_9 = {
    key: 0,
    class: "statusMessage mt-2 is-flex is-flex-direction-row"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-circle mt-1 mr-2" }, null, -1));
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "status" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "statusLabel" }, "Current Status:", -1));
const _hoisted_14 = {
    key: 0,
    class: "statusHistory mb-4"
};
const _hoisted_15 = { style: { "text-align": "left" } };
const _hoisted_16 = {
    key: 0,
    class: "historyPipe historyPipeDown"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "dot" }, null, -1));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = {
    key: 1,
    class: "historyPipe historyPipeBoth"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "dot" }, null, -1));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = {
    key: 2,
    class: "historyPipe historyPipeUp"
};
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "dot" }, null, -1));
const _hoisted_24 = [
    _hoisted_23
];
const _hoisted_25 = { class: "historyLabel" };
const _hoisted_26 = {
    key: 0,
    class: "historyPipe historyPipeBoth"
};
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { class: "historyDescription" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", null, null, -1));
const _hoisted_32 = [
    _hoisted_30,
    _hoisted_31
];
const _hoisted_33 = {
    key: 1,
    style: { "text-align": "center" },
    class: "mb-5"
};
const _hoisted_34 = { key: 2 };
const _hoisted_35 = {
    key: 3,
    class: "actionSection mb-5"
};
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "infoBox" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createElementVNode("strong", null, "The application has been cancelled"),
        /*#__PURE__*/ _createTextVNode(". The citizen will need to submit a new application if they wish to re-apply.")
    ])
], -1));
const _hoisted_37 = [
    _hoisted_36
];
const _hoisted_38 = {
    key: 4,
    class: "actionSection mb-5"
};
const _hoisted_39 = {
    key: 0,
    class: "infoBox"
};
const _hoisted_40 = { key: 0 };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the application"),
    /*#__PURE__*/ _createTextVNode(", and indicate whether it is ready to submit.")
], -1));
const _hoisted_42 = { class: "buttons mt-2" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-pen-nib mr-3" }, null, -1));
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_46 = { key: 1 };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "We are currently reviewing the application"),
    /*#__PURE__*/ _createTextVNode(" to see if it is ready to submit, or any amendments are required.")
], -1));
const _hoisted_48 = [
    _hoisted_47
];
const _hoisted_49 = {
    key: 1,
    class: "infoBox"
};
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Additional documentation is required"),
    /*#__PURE__*/ _createTextVNode(". Please review the comments in the tab below for more details about what is required, and upload / attach the documentation.")
], -1));
const _hoisted_51 = {
    key: 0,
    class: "buttons mt-2"
};
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-pen-nib mr-3" }, null, -1));
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_54 = {
    key: 2,
    class: "infoBox"
};
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Notarization is required. Please complete the process via the 'Notarization' tab below.")
], -1));
const _hoisted_56 = {
    key: 0,
    class: "buttons mt-2"
};
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_59 = {
    key: 3,
    class: "infoBox"
};
const _hoisted_60 = { key: 0 };
const _hoisted_61 = { key: 0 };
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application can be submitted by virtual mail - you do not need to print and mail it manually.")
], -1));
const _hoisted_63 = { class: "buttons mt-2" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_65 = { key: 1 };
const _hoisted_66 = { key: 0 };
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "There was an issue submitting this application by virtual mail.")
], -1));
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review any error messages and retry:")
], -1));
const _hoisted_69 = { class: "buttons mt-2" };
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Alternatively, you can submit manually:")
], -1));
const _hoisted_72 = { key: 1 };
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Please complete the process below to print and mail the application.", -1));
const _hoisted_74 = [
    _hoisted_73
];
const _hoisted_75 = {
    style: { "text-align": "left" },
    class: "mt-5"
};
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeDown" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "1. Download the application PDF, and print it")
], -1));
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1));
const _hoisted_78 = { class: "historyDescription pt-2" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "2. Attach appropriate payment to the application")
], -1));
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1));
const _hoisted_82 = { class: "historyDescription pt-2" };
const _hoisted_83 = {
    key: 0,
    class: "is-flex is-flex-direction-row subInfoBox"
};
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-money-bill-wave mt-1 mr-2" }, null, -1));
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "check", -1));
const _hoisted_86 = {
    key: 1,
    class: "is-flex is-flex-direction-row subInfoBox"
};
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-money-bill-wave mt-1 mr-2" }, null, -1));
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "money order", -1));
const _hoisted_89 = {
    key: 2,
    class: "is-flex is-flex-direction-row subInfoBox"
};
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mt-1 mr-2" }, null, -1));
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createTextVNode("This application "),
    /*#__PURE__*/ _createElementVNode("strong", null, "does not require"),
    /*#__PURE__*/ _createTextVNode(" payment to be enclosed.")
], -1));
const _hoisted_92 = [
    _hoisted_90,
    _hoisted_91
];
const _hoisted_93 = {
    key: 3,
    class: "is-flex is-flex-direction-row subInfoBox"
};
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mt-1 mr-2" }, null, -1));
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createTextVNode("Please "),
    /*#__PURE__*/ _createElementVNode("strong", null, "review the application form"),
    /*#__PURE__*/ _createTextVNode(" for information about required payment.")
], -1));
const _hoisted_96 = [
    _hoisted_94,
    _hoisted_95
];
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "3. Mail the complete application bundle to the state office")
], -1));
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1));
const _hoisted_99 = { class: "historyDescription" };
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, null, -1));
const _hoisted_101 = { key: 0 };
const _hoisted_102 = { class: "is-flex is-flex-direction-row is-align-items-center" };
const _hoisted_103 = { class: "subInfoBox is-flex is-flex-direction-row" };
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-map-pin mt-1 mr-2" }, null, -1));
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_108 = {
    key: 0,
    class: "ml-4"
};
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-tag mr-3" }, null, -1));
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-tag mr-3" }, null, -1));
const _hoisted_111 = { key: 1 };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeUp" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "4. Let us know once the application has been mailed")
], -1));
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "" }, null, -1));
const _hoisted_114 = { class: "historyDescription" };
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_116 = { key: 1 };
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "The application is ready, and will soon be submitted", -1));
const _hoisted_118 = {
    key: 4,
    class: "infoBox"
};
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been sent to the state records office"),
    /*#__PURE__*/ _createTextVNode(", and we are waiting for their response. ")
], -1));
const _hoisted_120 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please let us know"),
    /*#__PURE__*/ _createTextVNode(" when any updates on the application's status are received. ")
], -1));
const _hoisted_122 = { class: "buttons mt-3" };
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mr-3" }, null, -1));
const _hoisted_125 = {
    key: 5,
    class: "infoBox"
};
const _hoisted_126 = { key: 0 };
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "You have indicated that the application has been approved.", -1));
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please upload the digital copy below, and mail / deliver the physical records to the citizen's caseworker.")
], -1));
const _hoisted_129 = { class: "mt-4" };
const _hoisted_130 = { class: "buttons mt-2" };
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-handshake mr-3" }, null, -1));
const _hoisted_132 = { key: 1 };
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been approved"),
    /*#__PURE__*/ _createTextVNode(" by the state records office.")
], -1));
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "A digital copy of the citizen's birth record will be made available below as soon as possible, and the physical copy will be delivered to their caseworker.", -1));
const _hoisted_135 = { class: "mt-4" };
const _hoisted_136 = {
    key: 6,
    class: "infoBox"
};
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been rejected"),
    /*#__PURE__*/ _createTextVNode(" by the state records office.")
], -1));
const _hoisted_138 = { key: 0 };
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the reason for rejection"),
    /*#__PURE__*/ _createTextVNode(", and indicate the appropriate next step:")
], -1));
const _hoisted_140 = { class: "buttons mt-2" };
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-pen-nib mr-3" }, null, -1));
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_144 = { key: 1 };
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "We will review the reason for the rejection, and update you with any next steps required to resubmit the citizen's application.", -1));
const _hoisted_146 = [
    _hoisted_145
];
const _hoisted_147 = {
    key: 7,
    class: "infoBox"
};
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The citizen's birth records have been delivered to their caseworker"),
    /*#__PURE__*/ _createTextVNode(", and a digital copy will be made available to download below.")
], -1));
const _hoisted_149 = { class: "mt-4" };
const _hoisted_150 = {
    key: 5,
    class: "actionSection mb-5"
};
const _hoisted_151 = {
    key: 0,
    class: "infoBox"
};
const _hoisted_152 = { key: 0 };
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the application"),
    /*#__PURE__*/ _createTextVNode(", and indicate whether it is ready to submit.")
], -1));
const _hoisted_154 = { class: "buttons mt-2" };
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_157 = { key: 1 };
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "We are currently reviewing the application"),
    /*#__PURE__*/ _createTextVNode(" to see if it is ready to submit, or any amendments are required.")
], -1));
const _hoisted_159 = [
    _hoisted_158
];
const _hoisted_160 = {
    key: 1,
    class: "infoBox"
};
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Additional documentation is required"),
    /*#__PURE__*/ _createTextVNode(". Please review the comments in the tab below for more details about what is required, and upload / attach the documentation.")
], -1));
const _hoisted_162 = {
    key: 0,
    class: "buttons mt-2"
};
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_164 = {
    key: 2,
    class: "infoBox"
};
const _hoisted_165 = { key: 0 };
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please complete the process below to submit the application.")
], -1));
const _hoisted_167 = {
    style: { "text-align": "left" },
    class: "mt-5"
};
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeDown" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "1. Download the application PDF")
], -1));
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1));
const _hoisted_170 = { class: "historyDescription pt-2" };
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeUp" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "2. Fax, mail, or hand-submit the complete application bundle to the SSA")
], -1));
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "" }, null, -1));
const _hoisted_174 = { class: "historyDescription" };
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, null, -1));
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_177 = { key: 1 };
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "The application is ready, and will soon be submitted", -1));
const _hoisted_179 = {
    key: 3,
    class: "infoBox"
};
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been sent to the SSA"),
    /*#__PURE__*/ _createTextVNode(", and we are waiting for their response. ")
], -1));
const _hoisted_181 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please let us know"),
    /*#__PURE__*/ _createTextVNode(" when any updates on the application's status are received. ")
], -1));
const _hoisted_183 = { class: "buttons mt-3" };
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-comment mr-3" }, null, -1));
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mr-3" }, null, -1));
const _hoisted_187 = {
    key: 4,
    class: "infoBox"
};
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The citizen must attend an in-person appointment with the SSA"),
    /*#__PURE__*/ _createTextVNode(" to complete this application. ")
], -1));
const _hoisted_189 = {
    key: 0,
    class: "buttons mt-2"
};
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-comment mr-3" }, null, -1));
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mr-3" }, null, -1));
const _hoisted_193 = {
    key: 5,
    class: "infoBox"
};
const _hoisted_194 = { key: 0 };
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "You have indicated that the application has been approved.", -1));
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please upload a digital copy of the Social Security card below.")
], -1));
const _hoisted_197 = { class: "mt-4" };
const _hoisted_198 = { key: 1 };
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been approved"),
    /*#__PURE__*/ _createTextVNode(" by the SSA.")
], -1));
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "A digital copy of the citizen's Social Security card will be made available below as soon as possible.", -1));
const _hoisted_201 = { class: "mt-4" };
const _hoisted_202 = {
    key: 6,
    class: "infoBox"
};
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been rejected"),
    /*#__PURE__*/ _createTextVNode(" by the SSA.")
], -1));
const _hoisted_204 = { key: 0 };
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the reason for rejection"),
    /*#__PURE__*/ _createTextVNode(", and indicate the appropriate next step:")
], -1));
const _hoisted_206 = { class: "buttons mt-2" };
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_209 = { key: 1 };
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "We will review the reason for the rejection, and update you with any next steps required to resubmit the citizen's application.", -1));
const _hoisted_211 = [
    _hoisted_210
];
const _hoisted_212 = {
    key: 6,
    class: "actionSection mb-5"
};
const _hoisted_213 = {
    key: 0,
    class: "infoBox"
};
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been sent to the SSA"),
    /*#__PURE__*/ _createTextVNode(", and we are waiting for their response. ")
], -1));
const _hoisted_215 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please let us know"),
    /*#__PURE__*/ _createTextVNode(" when any updates on the application's status are received. ")
], -1));
const _hoisted_217 = { class: "buttons mt-3" };
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-comment mr-3" }, null, -1));
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mr-3" }, null, -1));
const _hoisted_221 = {
    key: 1,
    class: "infoBox"
};
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The citizen must attend an in-person appointment with the SSA"),
    /*#__PURE__*/ _createTextVNode(" to complete this application. ")
], -1));
const _hoisted_223 = {
    key: 0,
    class: "buttons mt-2"
};
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-comment mr-3" }, null, -1));
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mr-3" }, null, -1));
const _hoisted_227 = {
    key: 2,
    class: "infoBox"
};
const _hoisted_228 = { key: 0 };
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "You have indicated that the application has been approved.", -1));
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please upload a digital copy of the Social Security card below.")
], -1));
const _hoisted_231 = { class: "mt-4" };
const _hoisted_232 = { key: 1 };
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been approved"),
    /*#__PURE__*/ _createTextVNode(" by the SSA.")
], -1));
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "A digital copy of the citizen's Social Security card will be made available below as soon as possible.", -1));
const _hoisted_235 = { class: "mt-4" };
const _hoisted_236 = {
    key: 3,
    class: "infoBox"
};
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been rejected"),
    /*#__PURE__*/ _createTextVNode(" by the SSA.")
], -1));
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the reason for rejection"),
    /*#__PURE__*/ _createTextVNode(", and then have the citizen submit a new application via the "),
    /*#__PURE__*/ _createElementVNode("em", null, "my.minicityatl.com"),
    /*#__PURE__*/ _createTextVNode(" portal.")
], -1));
const _hoisted_239 = [
    _hoisted_237,
    _hoisted_238
];
const _hoisted_240 = {
    key: 4,
    class: "infoBox"
};
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The citizen can submit this application"),
    /*#__PURE__*/ _createTextVNode(" via the "),
    /*#__PURE__*/ _createElementVNode("em", null, "my.minicityatl.com"),
    /*#__PURE__*/ _createTextVNode(" portal.")
], -1));
const _hoisted_242 = [
    _hoisted_241
];
const _hoisted_243 = {
    key: 7,
    class: "actionSection mb-5"
};
const _hoisted_244 = {
    key: 0,
    class: "infoBox"
};
const _hoisted_245 = { key: 0 };
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the application"),
    /*#__PURE__*/ _createTextVNode(", and indicate whether it is ready to submit.")
], -1));
const _hoisted_247 = { class: "buttons mt-2" };
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_250 = { key: 1 };
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "We are currently reviewing the application"),
    /*#__PURE__*/ _createTextVNode(" to see if it is ready to submit, or any amendments are required.")
], -1));
const _hoisted_252 = [
    _hoisted_251
];
const _hoisted_253 = {
    key: 1,
    class: "infoBox"
};
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Additional documentation is required"),
    /*#__PURE__*/ _createTextVNode(". Please review the comments in the tab below for more details about what is required, and upload / attach the documentation.")
], -1));
const _hoisted_255 = {
    key: 0,
    class: "buttons mt-2"
};
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_257 = {
    key: 2,
    class: "infoBox"
};
const _hoisted_258 = { key: 0 };
const _hoisted_259 = { key: 0 };
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application can be submitted by virtual fax - you do not need to print and mail it manually.")
], -1));
const _hoisted_261 = { class: "buttons mt-2" };
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_263 = { key: 1 };
const _hoisted_264 = { key: 0 };
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "There was an issue faxing this application to the DFCS office.")
], -1));
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review any error messages and retry:")
], -1));
const _hoisted_267 = { class: "buttons mt-2" };
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Alternatively, you can submit manually:")
], -1));
const _hoisted_270 = { key: 1 };
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Please complete the process below to submit the application.", -1));
const _hoisted_272 = [
    _hoisted_271
];
const _hoisted_273 = {
    style: { "text-align": "left" },
    class: "mt-5"
};
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeDown" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "1. Download the application PDF")
], -1));
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeBoth" }, null, -1));
const _hoisted_276 = { class: "historyDescription pt-2" };
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-download mr-3" }, null, -1));
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", { class: "historyPipe historyPipeUp" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "dot" })
    ]),
    /*#__PURE__*/ _createElementVNode("td", { class: "historyLabel" }, "2. Fax, mail, or hand-submit the complete application bundle to the DFCS office")
], -1));
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "" }, null, -1));
const _hoisted_280 = { class: "historyDescription" };
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label mt-3" }, null, -1));
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-envelope mr-3" }, null, -1));
const _hoisted_283 = { key: 1 };
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "The application is ready, and will soon be submitted", -1));
const _hoisted_285 = {
    key: 3,
    class: "infoBox"
};
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been sent to the DFCS office"),
    /*#__PURE__*/ _createTextVNode(", and we are waiting for their response. ")
], -1));
const _hoisted_287 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please let us know"),
    /*#__PURE__*/ _createTextVNode(" when any updates on the application's status are received. ")
], -1));
const _hoisted_289 = { class: "buttons mt-3" };
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation mr-3" }, null, -1));
const _hoisted_292 = {
    key: 4,
    class: "infoBox"
};
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createElementVNode("strong", null, "The application has been approved"),
        /*#__PURE__*/ _createTextVNode(" by the DFCS office.")
    ]),
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
        /*#__PURE__*/ _createElementVNode("strong", null, "Please upload a digital copy of the confirmation below.")
    ])
], -1));
const _hoisted_294 = { class: "mt-4" };
const _hoisted_295 = {
    key: 5,
    class: "infoBox"
};
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "The application has been rejected"),
    /*#__PURE__*/ _createTextVNode(" by the DFCS office.")
], -1));
const _hoisted_297 = { key: 0 };
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Please review the reason for rejection"),
    /*#__PURE__*/ _createTextVNode(", and indicate the appropriate next step:")
], -1));
const _hoisted_299 = { class: "buttons mt-2" };
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file mr-3" }, null, -1));
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-3" }, null, -1));
const _hoisted_302 = { key: 1 };
const _hoisted_303 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "We will review the reason for the rejection, and update you with any next steps required to resubmit the citizen's application.", -1));
const _hoisted_304 = [
    _hoisted_303
];
import { formatDateAs, formatDollars } from '@/core/utils';
import { Core } from '@minicity/core';
import { computed, ref } from 'vue';
import MarkdownIt from "markdown-it";
import { isEntityManagedByMe } from '@/core/model';
import { doApiAction } from '@/core/api';
import { canSeeFeature } from '@/core/session';
import { RequestStatus } from './model';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { PaymentType } from './birthrecords/model';
import ApplicationFulfillmentTracker from './ApplicationFulfillmentTracker.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationStatusCard',
    props: {
        application: {},
        changeStatus: { type: Function },
        attachments: {},
        uploadAttachment: { type: Function },
        deleteAttachment: { type: Function },
        getAttachmentViewLink: { type: Function },
        downloadApplicationPDF: { type: Function },
        underlyingApplication: {},
        submitBirthRecordByVirtualMail: { type: Function },
        generateShippingLabel: { type: Function },
        downloadShippingLabel: { type: Function },
        submitGeorgiaBenefitsByFax: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const currentStatus = computed(() => {
            let status = null;
            for (let entry of props.application.history) {
                if (entry.type != "FUTURE") {
                    status = entry;
                }
            }
            return status;
        });
        const loading = ref(false);
        const virtualSubmissionFailed = ref(false);
        const doUploadAttachment = (uploadInfo) => {
            doApiAction(null, "uploadAttachment", "Attachment uploaded", "Failed to upload attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.uploadAttachment(uploadInfo.file).finally(() => uploadInfo.onDone());
            }));
        };
        const doDeleteAttachment = (doc) => {
            doApiAction(null, "deleteAttachment", "Attachment deleted", "Failed to delete attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.deleteAttachment(doc.id);
            }));
        };
        const doDownloadAttachment = (doc) => {
            doApiAction(null, "downloadAttachment", null, "Failed to download attachment", () => __awaiter(this, void 0, void 0, function* () {
                yield props.getAttachmentViewLink(doc.id)
                    .then((attachmentViewLink) => window.open(attachmentViewLink));
            }));
        };
        const doVirtualSubmission = (submitFunc) => __awaiter(this, void 0, void 0, function* () {
            loading.value = true;
            submitFunc()
                .catch(() => {
                loading.value = false;
                virtualSubmissionFailed.value = true;
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createTextVNode(_toDisplayString(_ctx.application.name) + " ", 1),
                            _createElementVNode("span", _hoisted_5, "(ID: " + _toDisplayString(_ctx.application.id) + ")", 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatDateAs)(_ctx.application.submittedAt, "MM/DD/YYYY")), 1)
                        ]),
                        (_ctx.application.statusMessage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", {
                                    innerHTML: new (_unref(MarkdownIt))().render(_ctx.application.statusMessage)
                                }, null, 8, _hoisted_11)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", {
                            style: { "width": "fit-content" },
                            class: _normalizeClass(["statusName my-1", currentStatus.value.type])
                        }, _toDisplayString(currentStatus.value.label), 3)
                    ])
                ]),
                (currentStatus.value.statusId != 'CANCELLED')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("table", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.application.history, (item, idx) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                    _createElementVNode("tr", {
                                        class: _normalizeClass(item.type)
                                    }, [
                                        (idx == 0)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_16, _hoisted_18))
                                            : (idx < _ctx.application.history.length - 1)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_19, _hoisted_21))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_22, _hoisted_24)),
                                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.label), 1)
                                    ], 2),
                                    _createElementVNode("tr", null, [
                                        (idx != _ctx.application.history.length - 1)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_26))
                                            : (_openBlock(), _createElementBlock("td", _hoisted_27)),
                                        _createElementVNode("td", _hoisted_28, _toDisplayString(item.date ? `${_unref(formatDateAs)(item.date, 'MM/DD/YYYY')}: ` : '') + _toDisplayString(item.description), 1)
                                    ]),
                                    (idx != _ctx.application.history.length - 1)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_32))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(LoadingSpinner)
                    ]))
                    : (!_ctx.changeStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                        : (currentStatus.value.statusId == 'CANCELLED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                            : (_ctx.application.applicationType == _unref(Core).EntityType['Birth Record'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    (currentStatus.value.statusId == 'NEW')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                    _hoisted_41,
                                                    _createElementVNode("div", _hoisted_42, [
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                        }, [
                                                            _hoisted_43,
                                                            _createTextVNode(" Additional Documentation Is Required ")
                                                        ]),
                                                        (_ctx.underlyingApplication.notarizationRequired)
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 0,
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).NOTARY_REQUIRED)))
                                                            }, [
                                                                _hoisted_44,
                                                                _createTextVNode(" Notarization Is Required ")
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                        }, [
                                                            _hoisted_45,
                                                            _createTextVNode(" Application Is Ready To Submit ")
                                                        ])
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'DOCS_REQUIRED')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            _hoisted_50,
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                    (_ctx.underlyingApplication.notarizationRequired)
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 0,
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).NOTARY_REQUIRED)))
                                                        }, [
                                                            _hoisted_52,
                                                            _createTextVNode(" Notarization Is Required ")
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("a", {
                                                        class: "button is-link mt-2",
                                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                    }, [
                                                        _hoisted_53,
                                                        _createTextVNode(" Application Is Ready To Submit ")
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'NOTARY_REQUIRED')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _hoisted_55,
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                    _createElementVNode("a", {
                                                        class: "button is-link mt-2",
                                                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                    }, [
                                                        _hoisted_57,
                                                        _createTextVNode(" Additional Documentation Is Required ")
                                                    ]),
                                                    _createElementVNode("a", {
                                                        class: "button is-link mt-2",
                                                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                    }, [
                                                        _hoisted_58,
                                                        _createTextVNode(" Application Is Ready To Submit ")
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'READY_TO_SUBMIT')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                    (_ctx.submitBirthRecordByVirtualMail && !virtualSubmissionFailed.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                            _hoisted_62,
                                                            _createElementVNode("div", _hoisted_63, [
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[7] || (_cache[7] = ($event) => (doVirtualSubmission(_ctx.submitBirthRecordByVirtualMail)))
                                                                }, [
                                                                    _hoisted_64,
                                                                    _createTextVNode(" Submit By Virtual Mail ")
                                                                ])
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                            (_ctx.submitBirthRecordByVirtualMail && virtualSubmissionFailed.value)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                                    _hoisted_67,
                                                                    _hoisted_68,
                                                                    _createElementVNode("div", _hoisted_69, [
                                                                        _createElementVNode("a", {
                                                                            class: "button is-link mt-2",
                                                                            onClick: _cache[8] || (_cache[8] = ($event) => (doVirtualSubmission(_ctx.submitBirthRecordByVirtualMail)))
                                                                        }, [
                                                                            _hoisted_70,
                                                                            _createTextVNode(" Retry Virtual Mail Submission ")
                                                                        ])
                                                                    ]),
                                                                    _hoisted_71
                                                                ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_74)),
                                                            _createElementVNode("table", _hoisted_75, [
                                                                _hoisted_76,
                                                                _createElementVNode("tr", null, [
                                                                    _hoisted_77,
                                                                    _createElementVNode("td", _hoisted_78, [
                                                                        _createElementVNode("a", {
                                                                            class: "button is-link",
                                                                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.downloadApplicationPDF()))
                                                                        }, [
                                                                            _hoisted_79,
                                                                            _createTextVNode(" Download Application PDF ")
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _hoisted_80,
                                                                _createElementVNode("tr", null, [
                                                                    _hoisted_81,
                                                                    _createElementVNode("td", _hoisted_82, [
                                                                        (_ctx.underlyingApplication.stateMailingInfo.paymentType == _unref(PaymentType).CHECK)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                                                                _hoisted_84,
                                                                                _createElementVNode("div", null, [
                                                                                    _createTextVNode("A "),
                                                                                    _hoisted_85,
                                                                                    _createTextVNode(" for "),
                                                                                    _createElementVNode("strong", null, _toDisplayString(_unref(formatDollars)(_ctx.underlyingApplication.stateMailingInfo.paymentAmount)), 1),
                                                                                    _createTextVNode(" must be enclosed.")
                                                                                ])
                                                                            ]))
                                                                            : (_ctx.underlyingApplication.stateMailingInfo.paymentType == _unref(PaymentType).MONEY_ORDER)
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                                                    _hoisted_87,
                                                                                    _createElementVNode("div", null, [
                                                                                        _createTextVNode("A "),
                                                                                        _hoisted_88,
                                                                                        _createTextVNode(" for "),
                                                                                        _createElementVNode("strong", null, _toDisplayString(_unref(formatDollars)(_ctx.underlyingApplication.stateMailingInfo.paymentAmount)), 1),
                                                                                        _createTextVNode(" must be enclosed.")
                                                                                    ])
                                                                                ]))
                                                                                : (_ctx.underlyingApplication.stateMailingInfo.paymentType == _unref(PaymentType).NONE)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, _hoisted_92))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_93, _hoisted_96))
                                                                    ])
                                                                ]),
                                                                _hoisted_97,
                                                                _createElementVNode("tr", null, [
                                                                    _hoisted_98,
                                                                    _createElementVNode("td", _hoisted_99, [
                                                                        _hoisted_100,
                                                                        (_ctx.underlyingApplication.stateMailingInfo.address)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                                                _createElementVNode("div", _hoisted_102, [
                                                                                    _createElementVNode("div", _hoisted_103, [
                                                                                        _hoisted_104,
                                                                                        _createElementVNode("div", null, [
                                                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.underlyingApplication.stateMailingInfo.recipientName), 1),
                                                                                            _hoisted_105,
                                                                                            _createElementVNode("strong", null, _toDisplayString((((_a = _ctx.underlyingApplication.stateMailingInfo.address.number) !== null && _a !== void 0 ? _a : '') + ' ' + ((_b = _ctx.underlyingApplication.stateMailingInfo.address.street) !== null && _b !== void 0 ? _b : '')).trim()), 1),
                                                                                            _hoisted_106,
                                                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.underlyingApplication.stateMailingInfo.address.city) + ", " + _toDisplayString(_ctx.underlyingApplication.stateMailingInfo.address.state), 1),
                                                                                            _hoisted_107,
                                                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.underlyingApplication.stateMailingInfo.address.postalCode), 1)
                                                                                        ])
                                                                                    ]),
                                                                                    (_unref(canSeeFeature)('shipping_label_printing'))
                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                                                                            (((_c = _ctx.underlyingApplication.fulfillment) === null || _c === void 0 ? void 0 : _c.method) == 'SHIPPING_LABEL')
                                                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                                                    key: 0,
                                                                                                    class: "button is-link",
                                                                                                    onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.downloadShippingLabel()))
                                                                                                }, [
                                                                                                    _hoisted_109,
                                                                                                    _createTextVNode(" Download Shipping Label ")
                                                                                                ]))
                                                                                                : (_openBlock(), _createElementBlock("a", {
                                                                                                    key: 1,
                                                                                                    class: "button is-link",
                                                                                                    onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.generateShippingLabel()))
                                                                                                }, [
                                                                                                    _hoisted_110,
                                                                                                    _createTextVNode(" Generate Shipping Label ")
                                                                                                ]))
                                                                                        ]))
                                                                                        : _createCommentVNode("", true)
                                                                                ])
                                                                            ]))
                                                                            : (_openBlock(), _createElementBlock("p", _hoisted_111, "Please check the application form for the appropriate mailing address for this state."))
                                                                    ])
                                                                ]),
                                                                _hoisted_112,
                                                                _createElementVNode("tr", null, [
                                                                    _hoisted_113,
                                                                    _createElementVNode("td", _hoisted_114, [
                                                                        _createElementVNode("a", {
                                                                            class: "button is-link mt-2",
                                                                            onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).SUBMITTED)))
                                                                        }, [
                                                                            _hoisted_115,
                                                                            _createTextVNode(" Application Has Been Mailed ")
                                                                        ])
                                                                    ])
                                                                ])
                                                            ])
                                                        ]))
                                                ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_116, [
                                                    _hoisted_117,
                                                    _createTextVNode(" to the state records office. ")
                                                ]))
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'SUBMITTED')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                            _hoisted_119,
                                            _createVNode(ApplicationFulfillmentTracker, {
                                                fulfillment: _ctx.underlyingApplication.fulfillment,
                                                class: "mt-4 mb-4"
                                            }, null, 8, ["fulfillment"]),
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                    _hoisted_121,
                                                    _createElementVNode("div", _hoisted_122, [
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPROVED)))
                                                        }, [
                                                            _hoisted_123,
                                                            _createTextVNode(" Application Was Approved ")
                                                        ]),
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).REJECTED)))
                                                        }, [
                                                            _hoisted_124,
                                                            _createTextVNode(" Application Was Rejected ")
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'APPROVED')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                    _hoisted_127,
                                                    _hoisted_128,
                                                    _createElementVNode("div", _hoisted_129, [
                                                        _createVNode(_component_DocumentUploadWidget, {
                                                            documents: _ctx.attachments,
                                                            onUpload: _cache[15] || (_cache[15] = ($event) => (doUploadAttachment($event))),
                                                            onDelete: _cache[16] || (_cache[16] = ($event) => (doDeleteAttachment($event))),
                                                            onView: _cache[17] || (_cache[17] = ($event) => (doDownloadAttachment($event)))
                                                        }, null, 8, ["documents"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_130, [
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[18] || (_cache[18] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DELIVERED)))
                                                        }, [
                                                            _hoisted_131,
                                                            _createTextVNode(" Records have been delivered ")
                                                        ])
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                                    _hoisted_133,
                                                    _hoisted_134,
                                                    _createElementVNode("div", _hoisted_135, [
                                                        _createVNode(_component_DocumentUploadWidget, {
                                                            documents: _ctx.attachments,
                                                            onUpload: _cache[19] || (_cache[19] = ($event) => (doUploadAttachment($event))),
                                                            onDelete: _cache[20] || (_cache[20] = ($event) => (doDeleteAttachment($event))),
                                                            onView: _cache[21] || (_cache[21] = ($event) => (doDownloadAttachment($event)))
                                                        }, null, 8, ["documents"])
                                                    ])
                                                ]))
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'REJECTED')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                            _hoisted_137,
                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                                    _hoisted_139,
                                                    _createElementVNode("div", _hoisted_140, [
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[22] || (_cache[22] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                        }, [
                                                            _hoisted_141,
                                                            _createTextVNode(" Additional Documentation Is Required ")
                                                        ]),
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[23] || (_cache[23] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).NOTARY_REQUIRED)))
                                                        }, [
                                                            _hoisted_142,
                                                            _createTextVNode(" Notarization Is Required ")
                                                        ]),
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[24] || (_cache[24] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                        }, [
                                                            _hoisted_143,
                                                            _createTextVNode(" Application Is Ready To Submit ")
                                                        ])
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_144, _hoisted_146))
                                        ]))
                                        : _createCommentVNode("", true),
                                    (currentStatus.value.statusId == 'DELIVERED')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                            _hoisted_148,
                                            _createElementVNode("div", _hoisted_149, [
                                                _createVNode(_component_DocumentUploadWidget, {
                                                    documents: _ctx.attachments,
                                                    onUpload: _cache[25] || (_cache[25] = ($event) => (doUploadAttachment($event))),
                                                    onDelete: _cache[26] || (_cache[26] = ($event) => (doDeleteAttachment($event))),
                                                    onView: _cache[27] || (_cache[27] = ($event) => (doDownloadAttachment($event)))
                                                }, null, 8, ["documents"])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : (_ctx.application.applicationType == _unref(Core).EntityType['Social Security'])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                        (currentStatus.value.statusId == 'NEW')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                                        _hoisted_153,
                                                        _createElementVNode("div", _hoisted_154, [
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[28] || (_cache[28] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                            }, [
                                                                _hoisted_155,
                                                                _createTextVNode(" Additional Documentation Is Required ")
                                                            ]),
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[29] || (_cache[29] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                            }, [
                                                                _hoisted_156,
                                                                _createTextVNode(" Application Is Ready To Submit ")
                                                            ])
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_157, _hoisted_159))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (currentStatus.value.statusId == 'DOCS_REQUIRED')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                                _hoisted_161,
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[30] || (_cache[30] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                        }, [
                                                            _hoisted_163,
                                                            _createTextVNode(" Application Is Ready To Submit ")
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (currentStatus.value.statusId == 'READY_TO_SUBMIT')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                                        _hoisted_166,
                                                        _createElementVNode("table", _hoisted_167, [
                                                            _hoisted_168,
                                                            _createElementVNode("tr", null, [
                                                                _hoisted_169,
                                                                _createElementVNode("td", _hoisted_170, [
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link",
                                                                        onClick: _cache[31] || (_cache[31] = ($event) => (_ctx.downloadApplicationPDF()))
                                                                    }, [
                                                                        _hoisted_171,
                                                                        _createTextVNode(" Download Application PDF ")
                                                                    ])
                                                                ])
                                                            ]),
                                                            _hoisted_172,
                                                            _createElementVNode("tr", null, [
                                                                _hoisted_173,
                                                                _createElementVNode("td", _hoisted_174, [
                                                                    _hoisted_175,
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[32] || (_cache[32] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).SUBMITTED)))
                                                                    }, [
                                                                        _hoisted_176,
                                                                        _createTextVNode(" Application Has Been Submitted ")
                                                                    ])
                                                                ])
                                                            ])
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_177, [
                                                        _hoisted_178,
                                                        _createTextVNode(" to the SSA. ")
                                                    ]))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (currentStatus.value.statusId == 'SUBMITTED')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                                _hoisted_180,
                                                _createVNode(ApplicationFulfillmentTracker, {
                                                    fulfillment: _ctx.underlyingApplication.fulfillment,
                                                    class: "mt-4 mb-4"
                                                }, null, 8, ["fulfillment"]),
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                                        _hoisted_182,
                                                        _createElementVNode("div", _hoisted_183, [
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[33] || (_cache[33] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPOINTMENT_REQUIRED)))
                                                            }, [
                                                                _hoisted_184,
                                                                _createTextVNode(" In-Person Appointment Required ")
                                                            ]),
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[34] || (_cache[34] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPROVED)))
                                                            }, [
                                                                _hoisted_185,
                                                                _createTextVNode(" Application Was Approved ")
                                                            ]),
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[35] || (_cache[35] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).REJECTED)))
                                                            }, [
                                                                _hoisted_186,
                                                                _createTextVNode(" Application Was Rejected ")
                                                            ])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (currentStatus.value.statusId == 'APPOINTMENT_REQUIRED')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                                _hoisted_188,
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[36] || (_cache[36] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).SUBMITTED)))
                                                        }, [
                                                            _hoisted_190,
                                                            _createTextVNode(" Citizen Has Completed Appointment ")
                                                        ]),
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[37] || (_cache[37] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPROVED)))
                                                        }, [
                                                            _hoisted_191,
                                                            _createTextVNode(" Application Was Approved ")
                                                        ]),
                                                        _createElementVNode("a", {
                                                            class: "button is-link mt-2",
                                                            onClick: _cache[38] || (_cache[38] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).REJECTED)))
                                                        }, [
                                                            _hoisted_192,
                                                            _createTextVNode(" Application Was Rejected ")
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (currentStatus.value.statusId == 'APPROVED')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                                        _hoisted_195,
                                                        _hoisted_196,
                                                        _createElementVNode("div", _hoisted_197, [
                                                            _createVNode(_component_DocumentUploadWidget, {
                                                                documents: _ctx.attachments,
                                                                onUpload: _cache[39] || (_cache[39] = ($event) => (doUploadAttachment($event))),
                                                                onDelete: _cache[40] || (_cache[40] = ($event) => (doDeleteAttachment($event))),
                                                                onView: _cache[41] || (_cache[41] = ($event) => (doDownloadAttachment($event)))
                                                            }, null, 8, ["documents"])
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                                        _hoisted_199,
                                                        _hoisted_200,
                                                        _createElementVNode("div", _hoisted_201, [
                                                            _createVNode(_component_DocumentUploadWidget, {
                                                                documents: _ctx.attachments,
                                                                onUpload: _cache[42] || (_cache[42] = ($event) => (doUploadAttachment($event))),
                                                                onDelete: _cache[43] || (_cache[43] = ($event) => (doDeleteAttachment($event))),
                                                                onView: _cache[44] || (_cache[44] = ($event) => (doDownloadAttachment($event)))
                                                            }, null, 8, ["documents"])
                                                        ])
                                                    ]))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (currentStatus.value.statusId == 'REJECTED')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                                                _hoisted_203,
                                                (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                                        _hoisted_205,
                                                        _createElementVNode("div", _hoisted_206, [
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[45] || (_cache[45] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                            }, [
                                                                _hoisted_207,
                                                                _createTextVNode(" Additional Documentation Is Required ")
                                                            ]),
                                                            _createElementVNode("a", {
                                                                class: "button is-link mt-2",
                                                                onClick: _cache[46] || (_cache[46] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                            }, [
                                                                _hoisted_208,
                                                                _createTextVNode(" Application Is Ready To Submit ")
                                                            ])
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_209, _hoisted_211))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : (_ctx.application.applicationType == _unref(Core).EntityType['Online Social Security'])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                            (currentStatus.value.statusId == 'SUBMITTED')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                                                    _hoisted_214,
                                                    _createVNode(ApplicationFulfillmentTracker, {
                                                        fulfillment: _ctx.underlyingApplication.fulfillment,
                                                        class: "mt-4 mb-4"
                                                    }, null, 8, ["fulfillment"]),
                                                    (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                                                            _hoisted_216,
                                                            _createElementVNode("div", _hoisted_217, [
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[47] || (_cache[47] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPOINTMENT_REQUIRED)))
                                                                }, [
                                                                    _hoisted_218,
                                                                    _createTextVNode(" In-Person Appointment Required ")
                                                                ]),
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[48] || (_cache[48] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPROVED)))
                                                                }, [
                                                                    _hoisted_219,
                                                                    _createTextVNode(" Application Was Approved ")
                                                                ]),
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[49] || (_cache[49] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).REJECTED)))
                                                                }, [
                                                                    _hoisted_220,
                                                                    _createTextVNode(" Application Was Rejected ")
                                                                ])
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : (currentStatus.value.statusId == 'APPOINTMENT_REQUIRED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                                        _hoisted_222,
                                                        (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[50] || (_cache[50] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).SUBMITTED)))
                                                                }, [
                                                                    _hoisted_224,
                                                                    _createTextVNode(" Citizen Has Completed Appointment ")
                                                                ]),
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[51] || (_cache[51] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPROVED)))
                                                                }, [
                                                                    _hoisted_225,
                                                                    _createTextVNode(" Application Was Approved ")
                                                                ]),
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[52] || (_cache[52] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).REJECTED)))
                                                                }, [
                                                                    _hoisted_226,
                                                                    _createTextVNode(" Application Was Rejected ")
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : (currentStatus.value.statusId == 'APPROVED')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                                            (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                                                    _hoisted_229,
                                                                    _hoisted_230,
                                                                    _createElementVNode("div", _hoisted_231, [
                                                                        _createVNode(_component_DocumentUploadWidget, {
                                                                            documents: _ctx.attachments,
                                                                            onUpload: _cache[53] || (_cache[53] = ($event) => (doUploadAttachment($event))),
                                                                            onDelete: _cache[54] || (_cache[54] = ($event) => (doDeleteAttachment($event))),
                                                                            onView: _cache[55] || (_cache[55] = ($event) => (doDownloadAttachment($event)))
                                                                        }, null, 8, ["documents"])
                                                                    ])
                                                                ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                                                    _hoisted_233,
                                                                    _hoisted_234,
                                                                    _createElementVNode("div", _hoisted_235, [
                                                                        _createVNode(_component_DocumentUploadWidget, {
                                                                            documents: _ctx.attachments,
                                                                            onUpload: _cache[56] || (_cache[56] = ($event) => (doUploadAttachment($event))),
                                                                            onDelete: _cache[57] || (_cache[57] = ($event) => (doDeleteAttachment($event))),
                                                                            onView: _cache[58] || (_cache[58] = ($event) => (doDownloadAttachment($event)))
                                                                        }, null, 8, ["documents"])
                                                                    ])
                                                                ]))
                                                        ]))
                                                        : (currentStatus.value.statusId == 'REJECTED')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_236, _hoisted_239))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_240, _hoisted_242))
                                        ]))
                                        : (_ctx.application.applicationType == _unref(Core).EntityType['Georgia DFCS Benefits'])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                                (currentStatus.value.statusId == 'NEW')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                                                        (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                                                                _hoisted_246,
                                                                _createElementVNode("div", _hoisted_247, [
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[59] || (_cache[59] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                                    }, [
                                                                        _hoisted_248,
                                                                        _createTextVNode(" Additional Documentation Is Required ")
                                                                    ]),
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[60] || (_cache[60] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                                    }, [
                                                                        _hoisted_249,
                                                                        _createTextVNode(" Application Is Ready To Submit ")
                                                                    ])
                                                                ])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_250, _hoisted_252))
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (currentStatus.value.statusId == 'DOCS_REQUIRED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                                        _hoisted_254,
                                                        (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                                                                _createElementVNode("a", {
                                                                    class: "button is-link mt-2",
                                                                    onClick: _cache[61] || (_cache[61] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                                }, [
                                                                    _hoisted_256,
                                                                    _createTextVNode(" Application Is Ready To Submit ")
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (currentStatus.value.statusId == 'READY_TO_SUBMIT')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                                        (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                                                                (_ctx.submitGeorgiaBenefitsByFax && !virtualSubmissionFailed.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                                                                        _hoisted_260,
                                                                        _createElementVNode("div", _hoisted_261, [
                                                                            _createElementVNode("a", {
                                                                                class: "button is-link mt-2",
                                                                                onClick: _cache[62] || (_cache[62] = ($event) => (doVirtualSubmission(_ctx.submitGeorgiaBenefitsByFax)))
                                                                            }, [
                                                                                _hoisted_262,
                                                                                _createTextVNode(" Submit By Virtual Fax ")
                                                                            ])
                                                                        ])
                                                                    ]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_263, [
                                                                        (_ctx.submitGeorgiaBenefitsByFax && virtualSubmissionFailed.value)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                                                                                _hoisted_265,
                                                                                _hoisted_266,
                                                                                _createElementVNode("div", _hoisted_267, [
                                                                                    _createElementVNode("a", {
                                                                                        class: "button is-link mt-2",
                                                                                        onClick: _cache[63] || (_cache[63] = ($event) => (doVirtualSubmission(_ctx.submitGeorgiaBenefitsByFax)))
                                                                                    }, [
                                                                                        _hoisted_268,
                                                                                        _createTextVNode(" Retry Virtual Fax Submission ")
                                                                                    ])
                                                                                ]),
                                                                                _hoisted_269
                                                                            ]))
                                                                            : (_openBlock(), _createElementBlock("div", _hoisted_270, _hoisted_272)),
                                                                        _createElementVNode("table", _hoisted_273, [
                                                                            _hoisted_274,
                                                                            _createElementVNode("tr", null, [
                                                                                _hoisted_275,
                                                                                _createElementVNode("td", _hoisted_276, [
                                                                                    _createElementVNode("a", {
                                                                                        class: "button is-link",
                                                                                        onClick: _cache[64] || (_cache[64] = ($event) => (_ctx.downloadApplicationPDF()))
                                                                                    }, [
                                                                                        _hoisted_277,
                                                                                        _createTextVNode(" Download Application PDF ")
                                                                                    ])
                                                                                ])
                                                                            ]),
                                                                            _hoisted_278,
                                                                            _createElementVNode("tr", null, [
                                                                                _hoisted_279,
                                                                                _createElementVNode("td", _hoisted_280, [
                                                                                    _hoisted_281,
                                                                                    _createElementVNode("a", {
                                                                                        class: "button is-link mt-2",
                                                                                        onClick: _cache[65] || (_cache[65] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).SUBMITTED)))
                                                                                    }, [
                                                                                        _hoisted_282,
                                                                                        _createTextVNode(" Application Has Been Submitted ")
                                                                                    ])
                                                                                ])
                                                                            ])
                                                                        ])
                                                                    ]))
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("p", _hoisted_283, [
                                                                _hoisted_284,
                                                                _createTextVNode(" to the DFCS office. ")
                                                            ]))
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (currentStatus.value.statusId == 'SUBMITTED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                                                        _hoisted_286,
                                                        _createVNode(ApplicationFulfillmentTracker, {
                                                            fulfillment: _ctx.underlyingApplication.fulfillment,
                                                            class: "mt-4 mb-4"
                                                        }, null, 8, ["fulfillment"]),
                                                        (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_287, [
                                                                _hoisted_288,
                                                                _createElementVNode("div", _hoisted_289, [
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[66] || (_cache[66] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).APPROVED)))
                                                                    }, [
                                                                        _hoisted_290,
                                                                        _createTextVNode(" Application Was Approved ")
                                                                    ]),
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[67] || (_cache[67] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).REJECTED)))
                                                                    }, [
                                                                        _hoisted_291,
                                                                        _createTextVNode(" Application Was Rejected ")
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (currentStatus.value.statusId == 'APPROVED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                                                        _hoisted_293,
                                                        _createElementVNode("div", _hoisted_294, [
                                                            _createVNode(_component_DocumentUploadWidget, {
                                                                documents: _ctx.attachments,
                                                                onUpload: _cache[68] || (_cache[68] = ($event) => (doUploadAttachment($event))),
                                                                onDelete: _cache[69] || (_cache[69] = ($event) => (doDeleteAttachment($event))),
                                                                onView: _cache[70] || (_cache[70] = ($event) => (doDownloadAttachment($event)))
                                                            }, null, 8, ["documents"])
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (currentStatus.value.statusId == 'REJECTED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                                                        _hoisted_296,
                                                        (_unref(isEntityManagedByMe)(_ctx.application.applicationType))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_297, [
                                                                _hoisted_298,
                                                                _createElementVNode("div", _hoisted_299, [
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[71] || (_cache[71] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).DOCS_REQUIRED)))
                                                                    }, [
                                                                        _hoisted_300,
                                                                        _createTextVNode(" Additional Documentation Is Required ")
                                                                    ]),
                                                                    _createElementVNode("a", {
                                                                        class: "button is-link mt-2",
                                                                        onClick: _cache[72] || (_cache[72] = ($event) => (_ctx.changeStatus(_unref(RequestStatus).READY_TO_SUBMIT)))
                                                                    }, [
                                                                        _hoisted_301,
                                                                        _createTextVNode(" Application Is Ready To Submit ")
                                                                    ])
                                                                ])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_302, _hoisted_304))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
            ]));
        };
    }
});
